export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: 'AIzaSyCtwAj59pBRmYYOVvtjMt3xHltgNdrr2IQ',
    authDomain: 'matematykagryzie-prod.firebaseapp.com',
    projectId: 'matematykagryzie-prod',
    storageBucket: 'matematykagryzie-prod.appspot.com',
    messagingSenderId: '532935680298',
    appId: '1:532935680298:web:9beb38556d00cbae4c3e53',
    measurementId: 'G-8KN08KWXFS',
  },
};
